import { useState } from 'react';
import { AlertTriangle, GitBranch, Inbox, Plus } from 'lucide-react';
import { CreateTicketModal } from '@/components/shared/CreateTicketModal';

export const QuickActions = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [preselectedType, setPreselectedType] = useState('');

  const openWith = (type) => { setPreselectedType(type); setModalOpen(true); };

  return (
    <>
      <div data-testid="quick-actions" className="nexus-card relative overflow-hidden">
        <div className="p-3 border-b border-[var(--nexus-border)]">
          <h2 className="text-sm font-semibold text-[var(--nexus-text-primary)] tracking-wide">Quick Actions</h2>
        </div>
        <div className="p-3 flex flex-col gap-2">
          <button data-testid="quick-action-create" onClick={() => openWith('')}
            className="flex items-center gap-2 w-full px-3 py-2.5 rounded-lg bg-[#0d3d4d] border border-cyan-500/20 text-cyan-300 text-xs font-medium hover:bg-[#0f4a5c] transition-colors">
            <Plus size={14} /> Create Ticket
          </button>
          <button data-testid="quick-action-incident" onClick={() => openWith('INCIDENT')}
            className="flex items-center gap-2 w-full px-3 py-2 rounded-lg bg-[#4a1515] border border-red-500/20 text-red-300 text-xs font-medium hover:bg-red-500/20 transition-colors">
            <AlertTriangle size={14} /> Create Incident
          </button>
          <button data-testid="quick-action-change" onClick={() => openWith('CHANGE')}
            className="flex items-center gap-2 w-full px-3 py-2 rounded-lg bg-[#4d3000] border border-amber-500/20 text-amber-200 text-xs font-medium hover:bg-amber-500/20 transition-colors">
            <GitBranch size={14} /> New Change
          </button>
          <button data-testid="quick-action-request" onClick={() => openWith('REQUEST')}
            className="flex items-center gap-2 w-full px-3 py-2 rounded-lg bg-[#0d2847] border border-blue-500/20 text-blue-300 text-xs font-medium hover:bg-blue-500/20 transition-colors">
            <Inbox size={14} /> New Request
          </button>
        </div>
      </div>
      <CreateTicketModal isOpen={modalOpen} onClose={() => setModalOpen(false)} defaultType={preselectedType} />
    </>
  );
};
